import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-file-preview-modal',
  templateUrl: './file-preview-modal.component.html',
  styleUrls: ['./file-preview-modal.component.css']
})
export class FilePreviewModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
